import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import { AnalyticsService } from '../../services/analytics.service';
import { ApiService } from '../../api/api.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatRippleModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TermType } from '../../models/terms.model';

@Component({
  selector: 'app-select-payment-plan',
  standalone: true,
  imports: [
    MatDividerModule,
    MatChipsModule,
    MatRippleModule,
    MatButtonModule,
    MatRadioModule,
    MatCheckboxModule,
    FormsModule,
    MatProgressBarModule,
    CommonModule,
  ],
  templateUrl: './select-payment-plan.component.html',
  styleUrl: './select-payment-plan.component.scss',
})
export class SelectPaymentPlanComponent implements OnInit {
  showSpinner$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  selectedPlan: string = '';

  constructor(
    private api: ApiService,
    private router: Router,
    public route: ActivatedRoute,
    private analyticsService: AnalyticsService
  ) {
    route.snapshot.data['userDto'];
  }

  ngOnInit(): void {
    console.log(
      'Fetched terms: ',
      this.route.snapshot.data['termsDto'].termType
    );
    console.log('Fetched userId: ', this.route.snapshot.data['userDto'].id);
    console.log(
      'Do we have a company id? ',
      this.route.snapshot.data['userDto'].ownedCompanies[0].id
    );
  }

  displayCorrectPrice(price: any): string {
    const correctTypePrice: number = price as number;
    if (correctTypePrice > 1000) {
      return Math.floor(correctTypePrice / 12) + ' kr/månad';
    } else {
      return correctTypePrice + ' kr/månad';
    }
  }

  onClickCard(value: string) {
    this.selectedPlan = value;
  }

  onLinkClick(event: MouseEvent) {
    event.stopPropagation();
  }

  proceedToPayment() {
    this.showSpinner$.next(true);
    if (this.selectedPlan && this.selectedPlan != '') {
      // Send that user accepts Terms
      this.api
        .acceptTerms({
          companyId: this.route.snapshot.data['userDto'].ownedCompanies[0].id,
          termType: this.route.snapshot.data['termsDto'].termType,
        })
        .subscribe({
          next: () => {
            console.log('Terms accepted successfully!');
          },
          error: (err) => {
            console.log('ERROR when accepting Terms: ', err.message);
          },
        });
      console.log('Should send log to backend');
      this.api.sendUserCheckoutInitialization().subscribe({
        next: () => {
          console.log('Post was successfully sent');

          // Fire Google Analytics
          this.analyticsService.trackEvent(
            'proceeded_to_payment', // Event Name: Specific action
            `From: Web, Plan: ${this.selectedPlan}`, // Event Label: Context of the action
            'Payment Process', // Event Category: Logical grouping
            'User started payment process' // Event Description: Optional
          );
        },
        error: () => {
          console.log('Error when sending POST');
        },
      });
      this.api.startStripeCheckoutSession(this.selectedPlan).subscribe({
        next: (response) => {
          this.showSpinner$.next(false);
          window.open(response.url, '_self');
        },
        error: (error) => {
          this.showSpinner$.next(false);
          console.log('Fatal error when starting Stripe Check-out session!');
        },
        complete: () => {
          console.log('Start Stripe Check-Out session request COMPLETED');
        },
      });
    }
  }

  logOut() {
    localStorage.setItem('userToken', '');
    this.router.navigate(['']);
  }
}
